import { useState, useEffect } from "react";
import MaterialTable from '@material-table/core';
import {
  Box,
  Typography,
  Grid,
  CircularProgress,
  Container,
  TextField,
} from "@mui/material";
import ActionButton from './actionButton';
import useWave from "../services/waveService";
import Alert from '@mui/material/Alert';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import ConfirmDialog from "./confirmDialog";

const ActorInWaveList = ({ actor, haveColor, clearActor }) => {

  const [searching, setSearching] = useState(false);
  const [selectValue, setSelectValue] = useState('');
  const scrollArea = Math.floor(window.innerHeight - 260)+"px";

  // The functions and data of Waves
  const {
    waveData,
    wavesData,
    countReady,
    isLoadingWave,
    waveServerError,
    addActorRow,
    fetchWaves,
    fetchActorByWave,
    toggleReady,
    goWave,
  } = useWave();
  const [showAlert, setShowAlert] = useState(true);
  const [confirmContent, setConfirmContent] = useState({
    message: "",
    okText: "",
    cancelText: "",
    actorID: "",
    actorState: ""
  });

  // Set the widths of the fields and buttons
  let teamFieldWidth = '180px';
  let teamSearchButtonWidth = '150px';

  if (window.innerWidth < 342) {          // In case of very small screens...
      if (haveColor) {
        teamFieldWidth = '185px';
        teamSearchButtonWidth = '110px';
      } else {
        teamFieldWidth = '165px';
        teamSearchButtonWidth = '130px';
      }
  } else if (haveColor) {
      teamFieldWidth = '200px';
      teamSearchButtonWidth = '140px';
  }

  const onCloseConfirm = (doChange) => {
    console.log("onCloseConfirm: ", doChange);
    setConfirmContent({ message: "", okText: "", cancelText: "" });
    clearActor();
    toggleReady(confirmContent.actorID, confirmContent.actorState, doChange);
  }

  useEffect(() => {
    setShowAlert(true);
  }, [isLoadingWave, setShowAlert]);

  useEffect(() => {
      fetchWaves();
    }, []);

  addActorRow(actor);

  const actorRowClicked = (event, rowData) => {
    console.log("rowClicked: ", rowData)
    rowData.tableData.checked = !rowData.tableData.checked;
    handleSelectChange (event, rowData);
  };

  const handleSelectChange = (event, rowData) => {
    if (rowData.state === "busy") {
      setConfirmContent({ message: "Zwemmer is al IN het water gemeld", 
        okText: "Herstel: zwemmer is NIET in het water!", 
        cancelText: "Ok",
        actorID: rowData.id,
        actorState: rowData.state });
    } else if (rowData.state === "done") {
      setConfirmContent({ message: "Zwemmer is al helemaal klaar en UIT het water gemeld.\nGebruik (indien nodig) het 'Uit het water'-scherm om dit terug te draaien.", 
        okText: "Deze regel van het scherm halen", 
        cancelText: "Ok",
        actorID: rowData.id,
        actorState: rowData.state });
    } else {
      clearActor();
      toggleReady(rowData.id, rowData.state, true);
    }
  };

  const handleWaveSelectedChange = (event: SelectChangeEvent) => {
    setSelectValue(event.target.value);
    // De laatst gevonden actor wordt leeg gemaakt zodat je alleen de deelnemers uit de wave te zien krijgt
    clearActor();
    fetchActorByWave(event.target.value);
  };

  const clickGo = () => {
    goWave(clearActor);
    setSelectValue(null);
  }

  return (
    <Box height="100%" id="ActorInWaveList-LargeBox">
      <Box id="TeamNameBox" marginTop="10px">
         {/* Select Wave dropdown */}
         <FormControl>
          <Container disableGutters sx={{ pl: '6px'}}>
            <InputLabel id="waves-label">Wave</InputLabel>
            {
            <Select labelId="waves-label"
            id="waveName"
            label="Wave"
            onChange={handleWaveSelectedChange}
            value={selectValue}
            sx={{ mr: 1, width: '180px' }}
            >
              {wavesData
                .map(wave => {return <MenuItem value={wave.waveName} key={wave.waveName}>{wave.waveName}</MenuItem>})}
            </Select>
            }
          </Container>
        </FormControl>
      </Box>
      <Box id="TeamTableBox" marginTop="6px" paddingLeft="10px" >
        {/* Hier wordt de tabel met de teamleden getoond 
            Met de actorData wordt de Teamnaam getoond en wordt de 1e entry van de list getoond.
            Met de button [Iedereen] wordt de lijst aangevuld met de andere teamleden.
            --
            Row color:
            - Ready:      row=green, font=white
            - Registered: row="#f2fafd" , font=black
            - Busy:       row=orange, font=black --> this is undoable
            - Done:       row=red, font=white --> this is NOT undoable
        */}
        {(waveData.length > 0) && <MaterialTable
          options={{
            showTitle: false,
            header: false,
            toolbar: false,
            paging: false,
            maxBodyHeight: scrollArea,
            rowStyle: rowData => ({
              backgroundColor:
               rowData.state === "ready" ? "#11973f"
               : rowData.state === "busy"  ? "#ffbf00"
                : rowData.state === "done" ? "#d62029"
                : (rowData.tableData.id % 2) === 0 ? "#e1f3fc" 
                : "#f2fafd",
              color:
                rowData.state === "busy" ? "black"
                : rowData.state === "registered" ? "black"
                : rowData.state === "initial" ? "black"
                : "white",
              fontWeight:
                rowData.state === "registered" || rowData.state === "initial" 
                ? "500"
                : "600"
            }),
            padding: 'dense',
            selection: true,
            selectionProps: rowData => ({ checked: rowData.state === "ready" }),
          }}
          title="Team"
          columns={[
          { title: 'ID', field: 'id', hidden: true },
          { title: 'Capnr', field: 'displayCapnr', width: 40 },
          { title: "Naam", field: "fullName" },
          //{ title: "Team", field: "teamName" },
          { title: "Wave", field: "displayWave" },
          ]}
          data={waveData}
          onSelectionChange={handleSelectChange}
          onRowClick={actorRowClicked}
        >
        </MaterialTable>}
      </Box>
      <Box id="GoButtonBox" position="absolute" bottom="10px" paddingRight="24px" paddingLeft="24px" width='100%' >
        {/* Hier wordt de GO! button getoond en wordt bij sumbit de functie "goTeam" aangeroepen. */}
        <Grid container id="GoButtonGrid" direction="row" >
          <Grid item id="GoButtonGridItem" xs={12} md={2} >
          <ActionButton 
            id="GoButton" 
            type="submit" 
            fullWidth color={(countReady() > 0) ? "buttonOrange" : "primary"}
            onClick={() => { clickGo()}} >
            {(countReady() > 0 ? ("GO! (" + countReady() + ")") : "CLEAR")}
          </ActionButton>
          </Grid>
        </Grid>
      </Box>
      {confirmContent.message.length > 0 && <ConfirmDialog id="ConfirmInActorInWaveList"
        message={confirmContent.message}
        severity="error"
        okText={confirmContent.okText}
        cancelText={confirmContent.cancelText}
        onClose={onCloseConfirm}
      />}
      {waveServerError && showAlert && (
        <Alert
          onClose={() => {
            setShowAlert(false);
          }}
          severity="error"
        >
        {waveServerError}
        </Alert>
      )}
      {isLoadingWave && <CircularProgress color="inherit" />}
    </Box>
  );
};

export default ActorInWaveList;

